(function (global) {
  'use strict';

  if (global.__rockEmCustomJerseyProductLoaded) return;
  global.__rockEmCustomJerseyProductLoaded = true;

  var configElement = document.getElementById('custom-jersey-product-config');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('[CustomJersey] Invalid product configuration:', error);
    return;
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    var roots = Array.from(
      document.querySelectorAll('[data-custom-jersey-product]')
    );
    if (!roots.length || !global.RockEmSoloCustomJerseyPreview) return;
    if (!global.RockEmJerseyValidation) {
      console.error('[CustomJersey] Name validation could not be loaded.');
      return;
    }
    var nameValidation = global.RockEmJerseyValidation.createValidator(config.badWords);

    var state = {
      product: config.product,
      variant: null,
      selectedSize: '',
      values: { name: '', number: '' },
      previewValues: { name: '', number: '' },
      groups: new Map(),
      preview: null,
      previewSku: '',
      previewTimer: null,
      previewRequest: 0,
      renderedMock: null,
      renderedValues: null,
      purchaseIntent: null,
      purchaseTimer: null,
      purchaseMessage: '',
      cartPending: false,
      selectionPending: false,
      uploadGeneration: 0,
      uploadTimer: null,
      uploadDebounceTimer: null,
      uploadRetryTimer: null,
      uploadController: null,
      uploadPending: false,
      uploadError: false,
      mockupUrl: '',
      jerseyTransaction: '',
      jerseyArtwork: null,
      numberSetId: '',
      numberSetImages: {},
      mockupKey: makeMockupKey(),
      selectionRequest: 0,
      combinables: null
    };
    var productSummaries = new WeakMap();

    roots.forEach(function (root, index) {
      root.dataset.customJerseyIndex = String(index);
      var swatches = root.querySelector('.tt-swatches-container-js');
      if (swatches && !swatches.id) {
        swatches.id = 'custom-jersey-swatches-' + index;
      }
    });

    function makeMockupKey() {
      if (global.crypto && typeof global.crypto.randomUUID === 'function') {
        return global.crypto.randomUUID();
      }
      return 'solo-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    }

    function productId(product) {
      return Number(String(product && product.id || '').split('/').pop());
    }

    function productOptions(product) {
      return Array.isArray(product && product.options) ? product.options : [];
    }

    function optionName(option) {
      return String(option && option.name !== undefined ? option.name : option || '').toLowerCase();
    }

    function sizeOptionIndex(product) {
      var index = productOptions(product).findIndex(function (option) {
        return optionName(option) === 'size' || optionName(option) === 'amount';
      });
      return index >= 0 ? index : 1;
    }

    function variantSize(product, variant) {
      if (!variant) return '';
      var options = Array.isArray(variant.options) ? variant.options : [];
      return String(
        options[sizeOptionIndex(product)] ||
        variant.option2 ||
        variant.option1 ||
        variant.title ||
        ''
      ).trim();
    }

    function findVariant(product, requestedSize) {
      var variants = Array.isArray(product && product.variants) ? product.variants : [];
      var wanted = String(requestedSize || '').trim().toLowerCase();
      var matches = wanted
        ? variants.filter(function (variant) {
            return variantSize(product, variant).toLowerCase() === wanted;
          })
        : [];
      return (
        matches.find(function (variant) { return variant.available; }) ||
        matches[0] ||
        variants.find(function (variant) { return variant.available; }) ||
        variants[0] ||
        null
      );
    }

    function previewSku(product) {
      var variants = Array.isArray(product && product.variants) ? product.variants : [];
      var variant = variants.find(function (item) {
        return /-LXL$/i.test(item.sku || '');
      }) || variants[0];
      return variant && variant.sku || '';
    }

    function visibleRoot() {
      return roots.find(function (root) { return root.offsetParent !== null; }) || roots[0];
    }

    function selectedSize(root) {
      var scope = root || visibleRoot();
      var selected = scope && (
        scope.querySelector('.new-size-group:not(.hidden) li.active a[data-value]') ||
        scope.querySelector('.new-options-list li.active a[data-value]')
      );
      return selected && selected.dataset.value
        ? selected.dataset.value.trim()
        : state.selectedSize;
    }

    function setFormVariant(variant) {
      if (!variant) return;
      roots.forEach(function (root) {
        root.querySelectorAll('input[name="id"]').forEach(function (input) {
          input.value = variant.id;
          input.setAttribute('value', variant.id);
        });
      });
    }

    function syncProperties() {
      roots.forEach(function (root) {
        root.querySelectorAll('.custom-jersey-number').forEach(function (input) {
          if (input.value !== state.values.number) input.value = state.values.number;
        });
        root.querySelectorAll('.custom-jersey-name').forEach(function (input) {
          if (input.value !== state.values.name) input.value = state.values.name;
        });
        root.querySelectorAll('.custom-jersey-number-property').forEach(function (input) {
          input.value = state.values.number;
        });
        root.querySelectorAll('.custom-jersey-name-property').forEach(function (input) {
          input.value = state.values.name;
        });
      });
      syncJerseyArtwork();
    }

    function jerseyArtworkReady() {
      if (config.renderer !== 'nfl-custom-jersey-2026') return true;
      var artwork = state.jerseyArtwork;
      return Boolean(artwork && state.variant &&
        artwork.transactionId && artwork.frontUrl && artwork.backUrl && artwork.url &&
        artwork.sku === state.variant.sku &&
        artwork.name === state.values.name && artwork.number === state.values.number &&
        artwork.numberSetId && artwork.numberSetId === state.numberSetId &&
        artwork.transactionId === state.jerseyTransaction && artwork.url === state.mockupUrl);
    }

    function syncJerseyArtwork() {
      if (config.renderer !== 'nfl-custom-jersey-2026') return;
      var artwork = state.jerseyArtwork || {};
      var fields = {
        '.nfl-jersey-transaction': artwork.transactionId,
        '.custom-jersey-number-set-property': artwork.numberSetId,
        '.nfl-jersey-purchased-sku': artwork.sku,
        '.nfl-jersey-selection-version': artwork.selectionVersion,
        '.nfl-jersey-front-art': artwork.frontUrl,
        '.nfl-jersey-back-art': artwork.backUrl,
        '.solo-custom-mockup-image': artwork.url
      };
      roots.forEach(function (root) {
        Object.keys(fields).forEach(function (selector) {
          root.querySelectorAll(selector).forEach(function (input) {
            input.value = fields[selector] || '';
          });
        });
      });
    }

    function containsBadWord(name) {
      return nameValidation.containsBadWord(name);
    }

    function propertiesValid() {
      var number = state.values.number;
      return (
        state.values.name.trim().length > 0 &&
        state.values.name.length <= 12 &&
        /^[A-Z ]+$/.test(state.values.name) &&
        !nameValidation.nameError(state.values.name) &&
        (config.renderer === 'nfl-custom-jersey-2026' ? /^\d{1,2}$/.test(number) : number === '' || /^\d{1,2}$/.test(number))
      );
    }

    function updateValidation() {
      var badName = containsBadWord(state.values.name);
      roots.forEach(function (root) {
        root.querySelectorAll('.custom-jersey-name').forEach(function (input) {
          var invalid = badName || state.values.name.length > 12 || !/^[A-Z ]*$/.test(state.values.name);
          input.classList.toggle('error', invalid);
          input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
        });
        root.querySelectorAll('.custom-jersey-number').forEach(function (input) {
          input.classList.toggle(
            'error',
            state.values.number !== '' && !/^\d{1,2}$/.test(state.values.number)
          );
        });
        var note = root.querySelector('.property-box-note');
        if (note) {
          var formatError = state.values.name !== '' && nameValidation.nameError(state.values.name) === 'format';
          note.textContent = badName ? 'Try another name' : 'Letters and spaces only, up to 12 characters';
          note.classList.toggle('hidden', !badName && !formatError);
        }
      });
      updateButtons();
    }

    function updateButtons() {
      if (config.renderer === 'nfl-custom-jersey-2026') {
        var busy = state.uploadPending || state.cartPending;
        var canAdd = Boolean(state.selectedSize) && propertiesValid() &&
          state.variant && state.variant.available && !state.selectionPending && !busy;
        roots.forEach(function (root) {
          root.querySelectorAll('.btn-addtocart').forEach(function (button) {
            button.disabled = !canAdd;
            button.classList.toggle('disable', !canAdd);
            button.classList.toggle('is-preparing-custom', busy);
            button.setAttribute('aria-busy', busy ? 'true' : 'false');
            button.setAttribute('aria-disabled', canAdd ? 'false' : 'true');
            button.textContent = state.cartPending ? 'Adding to Cart...'
              : state.uploadPending ? 'Preparing Your Pair...'
              : state.selectionPending ? 'Loading Design...'
              : !state.selectedSize ? 'Select Size'
              : state.variant && !state.variant.available ? 'Sold Out'
              : !propertiesValid() ? state.values.name ? 'Add Number' : 'Add Name'
              : state.purchaseMessage ? 'Try Again' : 'Add to Cart';
            button.style.setProperty('background', canAdd ? '#64B562' : '#bdbdbd', 'important');
            button.style.setProperty('pointer-events', canAdd ? 'auto' : 'none', 'important');
            button.style.setProperty('opacity', '1', 'important');
          });
          var message = root.querySelector('.custom-jersey-purchase-status');
          if (message) message.textContent = state.purchaseMessage;
        });
        return;
      }
      var enabled = Boolean(state.selectedSize) && propertiesValid() &&
        !state.uploadPending && Boolean(state.mockupUrl) &&
        (config.renderer !== 'nfl-custom-jersey-2026' || Boolean(state.jerseyTransaction)) &&
        jerseyArtworkReady() &&
        state.variant && state.variant.available;
      var canRetry = Boolean(state.selectedSize) && propertiesValid() &&
        !state.uploadPending && state.uploadError &&
        state.variant && state.variant.available;
      roots.forEach(function (root) {
        root.querySelectorAll('.btn-addtocart').forEach(function (button) {
          button.disabled = !(enabled || canRetry);
          button.classList.toggle('disable', !(enabled || canRetry));
          button.textContent = !state.selectedSize
            ? 'Select Size'
            : state.variant && !state.variant.available
            ? 'Sold Out'
            : state.uploadPending
              ? 'Rendering...'
              : enabled
                ? 'Add to Cart'
                : propertiesValid()
                  ? state.uploadError ? 'Retry Preview' : 'Rendering...'
                  : config.renderer === 'nfl-custom-jersey-2026' && state.values.name
                    ? 'Add Number' : 'Add Name';
          button.style.setProperty(
            'background',
            enabled ? '#64B562' : canRetry ? '#111111' : '#bdbdbd',
            'important'
          );
          button.style.setProperty('pointer-events', enabled || canRetry ? 'auto' : 'none', 'important');
          button.style.setProperty('opacity', '1', 'important');
        });
      });
    }

    function formatMoney(cents) {
      if (global.Shopify && typeof global.Shopify.formatMoney === 'function') {
        return global.Shopify.formatMoney(Number(cents) || 0, config.moneyFormat);
      }
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }

    function syncProductHeader(product, variant) {
      var parts = String(product.title || '').split(' - ');
      var collectionTitle = parts.length > 1 ? parts[0] : 'Custom Socks';
      var displayTitle = parts.length > 1 ? parts.slice(1).join(' - ') : product.title;
      document.querySelectorAll('.container-indent.mobile-only, .container-indent.desktop-only').forEach(function (container) {
        var title = container.querySelector('h1.tt-title');
        var collection = container.querySelector('.tt-collection-title');
        var price = container.querySelector('.tt-product-header .tt-price');
        if (title) title.textContent = displayTitle;
        if (collection) collection.textContent = collectionTitle;
        if (price) price.innerHTML = '<span class="new-price">' + formatMoney(variant.price) + '</span>';
      });

      document.querySelectorAll('.js-add-to-wishlist').forEach(function (button) {
        button.dataset.productId = product.id;
        button.dataset.productHandle = product.handle;
        button.dataset.productTitle = product.title;
        button.dataset.productImage = product.featured_image || product.images && product.images[0] || '';
        button.dataset.productPrice = product.price;
        button.dataset.productComparePrice = product.compare_at_price || '';
      });
    }

    function bindAddToCart() {
      if (!global.addToCartHandler || !global.jQuery) return;
      roots.forEach(function (root) {
        var $root = global.jQuery(root);
        global.addToCartHandler.initFormAddToCartButton(
          state.variant.id,
          $root,
          $root.find('.tt-swatches-container-js')
        );
      });
    }

    function applyVariant(variant, options) {
      if (!variant) return;
      state.variant = variant;
      setFormVariant(variant);
      syncProductHeader(state.product, variant);
      bindAddToCart();
      updateButtons();
      if (!options || options.updateUrl !== false) {
        var path = options && options.productChanged
          ? '/products/' + state.product.handle
          : global.location.pathname;
        if (global.history && global.history.replaceState) {
          global.history.replaceState(null, '', path + '?variant=' + variant.id);
        }
      }
    }

    function sizeLabel(value) {
      var label = String(value || '').trim();
      var compact = label.toUpperCase().replace(/[\s\/-]+/g, '');
      if (compact === 'SM') return 'S/M';
      if (compact === 'LXL') return 'L/XL';
      if (compact === 'YTHM' || compact === 'YOUTHM') return 'Youth M';
      if (compact === 'YTHL' || compact === 'YOUTHL' || compact === 'YTH' || compact === 'YOUTH') return 'Youth L';
      return label
        .replace(/^yth\s*/i, 'Youth ')
        .replace(/^youth(?=[a-z0-9])/i, 'Youth ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function sizeParts(value) {
      var raw = String(value || '').trim();
      var match = /^(.*?)\s*\(([^)]+)\)\s*$/.exec(raw);
      var label = sizeLabel(match ? match[1] : raw);
      var detail = match ? match[2].trim() : '';

      if (!detail) {
        if (/^s\/m$/i.test(label)) detail = '6-8.5';
        else if (/^l\/xl$/i.test(label)) detail = '9-13';
        else if (/^youth l$/i.test(label)) detail = '2-5.5';
        else if (/^youth m$/i.test(label)) detail = '11T-2';
      }

      if (detail && !/^sz\b/i.test(detail)) detail = 'sz ' + detail;
      return { label: label, detail: detail };
    }

    function productSizes(product) {
      var seen = new Set();
      var order = {
        'youth m': 0,
        'youth l': 1,
        's/m': 2,
        'l/xl': 3
      };
      return (product && product.variants || []).reduce(function (sizes, variant) {
        var value = variantSize(product, variant);
        var key = value.toLowerCase();
        if (!value || seen.has(key)) return sizes;
        seen.add(key);
        var parts = sizeParts(value);
        sizes.push({
          value: value,
          label: parts.label,
          detail: parts.detail,
          available: (product.variants || []).some(function (candidate) {
            return variantSize(product, candidate).toLowerCase() === key && candidate.available;
          })
        });
        return sizes;
      }, []).sort(function (left, right) {
        var leftRank = order[left.label.toLowerCase()];
        var rightRank = order[right.label.toLowerCase()];
        leftRank = leftRank === undefined ? Number.MAX_SAFE_INTEGER : leftRank;
        rightRank = rightRank === undefined ? Number.MAX_SAFE_INTEGER : rightRank;
        return leftRank - rightRank;
      });
    }

    function renderSizeList(sizes, selected, groupName) {
      var group = document.createElement('div');
      group.className = groupName ? 'new-size-group ' + groupName : 'custom-jersey-size-group';
      var list = document.createElement('ul');
      list.className = 'new-options-list socks';
      sizes.forEach(function (size) {
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#';
        link.dataset.value = size.value;
        var label = document.createElement('span');
        label.textContent = size.label;
        link.appendChild(label);
        if (size.detail) {
          var detail = document.createElement('span');
          detail.className = 'size-detail';
          detail.textContent = size.detail;
          link.appendChild(detail);
        }
        item.classList.toggle('active', size.value === selected);
        if (!size.available) item.dataset.availability = 'false';
        item.appendChild(link);
        list.appendChild(item);
      });
      group.appendChild(list);
      return group;
    }

    function renderSizePicker(root, product, variant) {
      var container = root.querySelector('.tt-swatches-container-js');
      if (!container) return;
      var sizes = productSizes(product);
      var selected = state.selectedSize;
      container.innerHTML = '';
      if (!sizes.length) return;

      var picker = document.createElement('div');
      picker.className = 'custom-jersey-size-picker';
      var guide = document.createElement('a');
      guide.href = '#';
      guide.className = 'size-guide-btn';
      guide.dataset.isNonSocks = 'false';
      guide.setAttribute('aria-label', 'Size Guide');
      var guideIcon = document.createElement('img');
      guideIcon.src = config.sizeGuideIcon;
      guideIcon.alt = '';
      guideIcon.className = 'size-guide-text';
      guideIcon.width = 65;
      guideIcon.height = 11;
      guide.appendChild(guideIcon);

      var youth = sizes.filter(function (size) { return /^youth\b/i.test(size.label); });
      var adult = sizes.filter(function (size) { return !/^youth\b/i.test(size.label); });
      if (global.innerWidth < 768 && youth.length && adult.length) {
        var visibleSize = selected || variantSize(product, variant);
        var selectedIsYouth = youth.some(function (size) { return size.value === visibleSize; });
        var toggles = document.createElement('div');
        toggles.className = 'new-toggle-switch';
        [
          { name: 'youth', label: 'YOUTH', active: selectedIsYouth },
          { name: 'adult', label: 'ADULT', active: !selectedIsYouth }
        ].forEach(function (group) {
          var tab = document.createElement('span');
          tab.className = 'new-toggle-item' + (group.active ? ' active' : '');
          tab.dataset.target = group.name;
          tab.textContent = group.label;
          toggles.appendChild(tab);
        });
        var toggleWrapper = document.createElement('div');
        toggleWrapper.className = 'new-toggle-wrapper';
        toggleWrapper.appendChild(guide);
        toggleWrapper.appendChild(toggles);
        picker.appendChild(toggleWrapper);
        var youthGroup = renderSizeList(youth, selected, 'youth');
        var adultGroup = renderSizeList(adult, selected, 'adult');
        youthGroup.classList.toggle('hidden', !selectedIsYouth);
        adultGroup.classList.toggle('hidden', selectedIsYouth);
        picker.appendChild(youthGroup);
        picker.appendChild(adultGroup);
      } else {
        picker.appendChild(guide);
        picker.appendChild(renderSizeList(sizes, selected, ''));
      }
      container.appendChild(picker);
    }

    function initSwatches(product, variant) {
      state.groups.clear();
      roots.forEach(function (root) { renderSizePicker(root, product, variant); });
      global.productData = product;
    }

    function markSize(root, size) {
      root.querySelectorAll('.new-options-list li').forEach(function (item) {
        var link = item.querySelector('a[data-value]');
        item.classList.toggle(
          'active',
          Boolean(link && link.dataset.value.trim() === size)
        );
      });
    }

    function selectSize(root, size) {
      var variant = findVariant(state.product, size);
      if (!variant) return;
      var changed = !state.variant || state.variant.id !== variant.id;
      if (changed && config.renderer === 'nfl-custom-jersey-2026') cancelMockupUpload(false);
      state.selectedSize = size;
      roots.forEach(function (item) { markSize(item, size); });
      applyVariant(variant);
    }

    function switchSizeTab(root, tab) {
      if (config.renderer === 'nfl-custom-jersey-2026') cancelMockupUpload(false);
      var target = tab.dataset.target;
      root.querySelectorAll('.new-toggle-item').forEach(function (item) {
        item.classList.toggle('active', item === tab);
      });
      root.querySelectorAll('.new-size-group').forEach(function (group) {
        group.classList.toggle('hidden', !group.classList.contains(target));
      });
      state.selectedSize = '';
      roots.forEach(function (item) { markSize(item, ''); });
      updateButtons();
    }

    function previewFallbackUrl(styleId) {
      if (config.renderer !== 'nfl-custom-jersey-2026') return '';
      var saved = config.previewImages;
      var id = styleId || state.numberSetId || saved && saved.defaultStyleId;
      if (state.numberSetImages[id]) return state.numberSetImages[id];
      if (productId(state.product) === productId(config.product) && saved && saved.images && saved.images[id]) return saved.images[id].url;
      var image = state.variant && state.variant.featured_image || state.product.featured_image || state.product.images && state.product.images[0];
      return image && (typeof image === 'string' ? image : image.src || image.url) || config.previewImage || '';
    }

    function setFallbackImage(wrapper, url) {
      if (!url || wrapper.dataset.failedFallback === url) return;
      var image = wrapper.querySelector('.solo-custom-preview-fallback');
      if (image.getAttribute('src') !== url) image.src = url;
      wrapper.classList.add('has-fallback');
    }

    function showPreviewFallback(styleId) {
      var url = previewFallbackUrl(styleId);
      document.querySelectorAll('.solo-custom-preview').forEach(function (wrapper) {
        setFallbackImage(wrapper, url);
        wrapper.classList.remove('is-ready');
      });
    }

    function getPreviewCanvases() {
      var targets = [
        {
          container: document.querySelector('.desktop-only .tt-product-single-img .mediaimageholder') ||
            document.querySelector('.tt-product-single-img .mediaimageholder'),
          kind: 'desktop'
        },
        {
          container: document.querySelector('.mobile-only .tt-product-single-img .mediaimageholder') ||
            document.querySelector('.mobile-only .tt-mobile-product-slider') ||
            document.querySelector('.tt-mobile-product-slider'),
          kind: 'mobile'
        }
      ];
      return targets.reduce(function (canvases, target) {
        if (!target.container) return canvases;
        var selector = '.solo-custom-preview[data-preview-kind="' + target.kind + '"]';
        var wrapper = target.container.querySelector(selector);
        if (!wrapper) {
          wrapper = document.createElement('span');
          wrapper.className = 'pplr_preview_wrapper solo-custom-preview';
          wrapper.dataset.previewKind = target.kind;
          wrapper.innerHTML = '<img class="solo-custom-preview-fallback" alt="Jersey preview with sample name and number" decoding="async">' +
            '<canvas aria-label="Customized sock preview"></canvas>' +
            '<span class="solo-custom-preview-status" aria-live="polite"></span>';
          wrapper.querySelector('.solo-custom-preview-fallback').onerror = function () { wrapper.dataset.failedFallback = this.getAttribute('src'); wrapper.classList.remove('has-fallback'); };
          setFallbackImage(wrapper, previewFallbackUrl());
          target.container.appendChild(wrapper);
          target.container.classList.add('pplr');
        }
        canvases.push(wrapper.querySelector('canvas'));
        return canvases;
      }, []);
    }

    function setPreviewStatus(status, message) {
      document.querySelectorAll('.solo-custom-preview').forEach(function (wrapper) {
        wrapper.classList.toggle('is-loading', status === 'loading');
        wrapper.classList.toggle('is-error', status === 'error');
        if (status === 'ready') wrapper.classList.add('is-ready');
        if (status === 'error' && wrapper.classList.contains('has-fallback')) wrapper.classList.remove('is-ready');
        var text = wrapper.querySelector('.solo-custom-preview-status');
        if (text) text.textContent = message || '';
      });
    }

    function ensurePreview() {
      var canvases = getPreviewCanvases();
      if (!canvases.length) return null;
      if (!state.preview) {
        state.preview = new global.RockEmSoloCustomJerseyPreview({
          endpoint: String(config.assetsEndpoint || '').replace(/\/+$/, '') + '/customProductAssets',
          maxProductCacheEntries: global.innerWidth < 768 ? 4 : 10,
          maxFrontLayerCacheEntries: 15,
          font: config.font,
          fontFamily: config.fontFamily,
          mockProfile: config.mockProfile,
          // Lift the NFL name track toward the cuff to match the art guide.
          meshes: config.meshes,
          layers: config.layers,
          canvases: canvases,
          onStatus: setPreviewStatus,
          onMetadata: syncDesignNumberSet,
          onRender: handlePreviewRender
        });
      } else {
        state.preview.config.canvases = canvases;
      }
      return state.preview;
    }

    function syncDesignNumberSet(product) {
      if (config.renderer !== 'nfl-custom-jersey-2026') return;
      var sets = product.customization.numberSets || [product.customization.numberSet];
      sets.forEach(function (set) { if (set.previewImage) state.numberSetImages[set.id] = set.previewImage; });
      // Each design product owns its number artwork; customers choose products through Combinables.
      state.numberSetId = product.customization.numberSet.id;
      document.querySelectorAll('.solo-custom-preview:not(.is-ready)').forEach(function (wrapper) { setFallbackImage(wrapper, previewFallbackUrl()); });
    }

    function setMockupUrl(url) {
      state.mockupUrl = url || '';
      roots.forEach(function (root) {
        root.querySelectorAll('.solo-custom-mockup-image').forEach(function (input) {
          input.value = state.mockupUrl;
        });
      });
    }

    function cancelMockupUpload(pending) {
      state.uploadGeneration += 1;
      clearTimeout(state.purchaseTimer);
      state.purchaseIntent = null;
      state.purchaseMessage = '';
      clearTimeout(state.uploadTimer);
      clearTimeout(state.uploadDebounceTimer);
      clearTimeout(state.uploadRetryTimer);
      if (state.uploadController) state.uploadController.abort();
      state.uploadController = null;
      state.uploadPending = config.renderer !== 'nfl-custom-jersey-2026' && Boolean(pending);
      state.uploadError = false;
      setMockupUrl('');
      state.jerseyTransaction = '';
      state.jerseyArtwork = null;
      syncJerseyArtwork();
    }

    function handlePreviewRender(mock, renderedValues) {
      if (config.renderer !== 'nfl-custom-jersey-2026') {
        uploadMockup(mock, renderedValues);
        return;
      }
      if (!uploadValuesMatch(renderedValues)) return;
      state.renderedMock = mock;
      state.renderedValues = Object.assign({}, renderedValues);
      if (state.purchaseIntent) uploadMockup(mock, renderedValues);
    }

    function preparePurchase(form) {
      readCustomization(form && form.closest('[data-custom-jersey-product]'));
      if (state.cartPending || state.purchaseIntent || state.selectionPending ||
          !form || !state.selectedSize || !propertiesValid() || !state.variant || !state.variant.available) return;
      if (!jerseyArtworkReady()) cancelMockupUpload(false);
      state.purchaseMessage = '';
      state.purchaseIntent = { form: form, generation: state.uploadGeneration, uploadStarted: false };
      if (jerseyArtworkReady()) {
        submitPreparedPurchase();
        return;
      }
      state.uploadPending = true;
      updateButtons();
      var generation = state.uploadGeneration;
      state.purchaseTimer = setTimeout(function () {
        if (state.purchaseIntent && generation === state.uploadGeneration) {
          cancelMockupUpload(false);
          state.purchaseMessage = 'Unable to prepare your pair. Please try again.';
          updateButtons();
        }
      }, 60000);
      // Reuse the visible mock; production tiles still use the purchased size.
      if (state.renderedMock && uploadValuesMatch(state.renderedValues)) {
        uploadMockup(state.renderedMock, state.renderedValues);
      } else {
        queuePreview(true, false);
      }
    }

    function submitPreparedPurchase() {
      var intent = state.purchaseIntent;
      if (intent) readCustomization(intent.form.closest('[data-custom-jersey-product]'));
      intent = state.purchaseIntent;
      if (!intent || intent.generation !== state.uploadGeneration || !state.selectedSize ||
          !propertiesValid() || !state.variant || !state.variant.available || !jerseyArtworkReady()) return;
      clearTimeout(state.purchaseTimer);
      state.purchaseIntent = null;
      state.uploadPending = false;
      state.cartPending = true;
      syncProperties();
      setFormVariant(state.variant);
      updateButtons();
      function failed() {
        state.cartPending = false;
        state.purchaseMessage = 'Unable to add your pair to the cart. Please try again.';
        updateButtons();
      }
      try {
        // Keep the theme's inventory checks, form serialization and cart UI.
        var request = global.Shopify.addItemFromForm(intent.form, function (item) {
          state.cartPending = false;
          state.mockupKey = makeMockupKey();
          updateButtons();
          global.Shopify.onItemAdded(item);
        });
        if (request === false) failed();
        else if (request && typeof request.then === 'function') {
          Promise.resolve(request).then(function (result) {
            if (result === false) failed();
          }, failed);
        }
      } catch (error) {
        failed();
        console.error('[CustomJersey] Cart error:', error);
      }
    }

    function uploadValuesMatch(renderedValues) {
      return renderedValues &&
        renderedValues._request === state.previewRequest &&
        renderedValues._sku === previewSku(state.product) &&
        (config.renderer !== 'nfl-custom-jersey-2026' || renderedValues._numberSet === state.numberSetId) &&
        String(renderedValues.name || '') === state.previewValues.name &&
        String(renderedValues.number || '') === state.previewValues.number;
    }

    function parseUploadResponse(response) {
      return response.text().then(function (body) {
        var data = null;
        try {
          data = body ? JSON.parse(body) : {};
        } catch (error) {
          data = {};
        }
        if (!response.ok) {
          var serverMessage = data.error || body || 'Unknown upload error';
          var uploadError = new Error(
            'Mock upload failed (' + response.status + '): ' + serverMessage
          );
          uploadError.status = response.status;
          uploadError.serverMessage = serverMessage;
          throw uploadError;
        }
        return data;
      });
    }

    function canRetryUpload(error) {
      return error && (
        error.timedOut ||
        (!error.status && error.name !== 'AbortError') ||
        error.status === 429 ||
        error.status === 500 ||
        error.status === 502 ||
        error.status === 503 ||
        error.status === 504
      );
    }

    function finishUploadError(error, generation, attempt) {
      if (generation !== state.uploadGeneration) return;
      clearTimeout(state.uploadTimer);
      state.uploadController = null;
      state.uploadPending = false;
      state.uploadError = true;
      setMockupUrl('');
      if (config.renderer === 'nfl-custom-jersey-2026') {
        clearTimeout(state.purchaseTimer);
        state.purchaseIntent = null;
        state.purchaseMessage = 'Unable to prepare your pair. Please try again.';
      } else {
        setPreviewStatus('error', 'Unable to prepare the custom preview. Please try again.');
      }
      updateButtons();
      console.error('[CustomJersey] Mock upload error:', error, {
        status: error && error.status || 0,
        serverMessage: error && error.serverMessage || '',
        attempts: attempt + 1
      });
    }

    function postMockup(body, generation, attempt, selection) {
      if (generation !== state.uploadGeneration) return;
      var timedOut = false;
      var controller = typeof global.AbortController === 'function'
        ? new global.AbortController()
        : null;
      state.uploadController = controller;
      clearTimeout(state.uploadTimer);
      state.uploadTimer = setTimeout(function () {
        if (generation !== state.uploadGeneration) return;
        timedOut = true;
        if (controller) controller.abort();
      }, 15000);

      var request = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
      };
      if (controller) request.signal = controller.signal;

      var endpoint = config.renderer === 'nfl-custom-jersey-2026' ? '/nflCustomJerseyUploader' : '/soloCustomMockUploader';
      fetch(String(config.assetsEndpoint).replace(/\/+$/, '') + endpoint, request)
        .then(parseUploadResponse)
        .then(function (data) {
          if (generation !== state.uploadGeneration) return;
          if (!data.url) throw new Error('Mock upload returned no URL');
          if (config.renderer === 'nfl-custom-jersey-2026') {
            if (!data.transactionId || !data.frontUrl || !data.backUrl) throw new Error('Custom artwork upload was incomplete.');
            if (!selection || !state.variant || selection.sku !== state.variant.sku ||
                selection.name !== state.values.name || selection.number !== state.values.number ||
                selection.numberSetId !== state.numberSetId) throw new Error('Custom artwork no longer matches the selection.');
            state.jerseyArtwork = Object.assign({}, selection, {
              transactionId: data.transactionId, frontUrl: data.frontUrl,
              backUrl: data.backUrl, url: data.url
            });
            state.jerseyTransaction = data.transactionId;
            syncJerseyArtwork();
          }
          clearTimeout(state.uploadTimer);
          state.uploadController = null;
          state.uploadPending = false;
          state.uploadError = false;
          setMockupUrl(data.url);
          setPreviewStatus('ready', '');
          updateButtons();
          if (config.renderer === 'nfl-custom-jersey-2026') submitPreparedPurchase();
        })
        .catch(function (error) {
          if (generation !== state.uploadGeneration) return;
          clearTimeout(state.uploadTimer);
          state.uploadController = null;
          if (timedOut) {
            var timeoutError = new Error('Mock upload timed out');
            timeoutError.timedOut = true;
            timeoutError.serverMessage = 'Request timed out';
            error = timeoutError;
          } else if (error && error.name === 'AbortError') {
            return;
          }
          if (attempt < 2 && canRetryUpload(error)) {
            state.uploadRetryTimer = setTimeout(function () {
              postMockup(body, generation, attempt + 1, selection);
            }, attempt === 0 ? 500 : 1250);
            return;
          }
          finishUploadError(error, generation, attempt);
        });
    }

    function uploadMockup(mock, renderedValues) {
      if (!mock || !mock.toDataURL || !config.assetsEndpoint ||
          !propertiesValid() || !uploadValuesMatch(renderedValues)) return;

      if (config.renderer === 'nfl-custom-jersey-2026') {
        if (!state.purchaseIntent || state.purchaseIntent.uploadStarted) return;
        state.purchaseIntent.uploadStarted = true;
      } else {
        cancelMockupUpload(true);
      }
      var generation = state.uploadGeneration;
      var mockupKey = state.mockupKey;
      updateButtons();
      state.uploadDebounceTimer = setTimeout(function () {
        if (generation !== state.uploadGeneration) return;
        var image;
        try {
          image = mock.toDataURL('image/webp', 0.9);
          if (image.indexOf('data:image/webp') !== 0) {
            image = mock.toDataURL('image/png');
          }
        } catch (error) {
          finishUploadError(error, generation, 0);
          return;
        }
        if (config.renderer === 'nfl-custom-jersey-2026') {
          var purchasedSku = state.variant.sku;
          state.preview.createPrintTiles(renderedValues, { sku: purchasedSku }).then(function (tiles) {
            if (generation !== state.uploadGeneration || !uploadValuesMatch(renderedValues)) return;
            var selection = {
              sku: purchasedSku, name: renderedValues.name, number: renderedValues.number,
              numberSetId: renderedValues._numberSet,
              selectionVersion: tiles.selectionVersion || state.preview.product.customization.designSelection && state.preview.product.customization.designSelection.selectionVersion
            };
            postMockup(JSON.stringify(Object.assign({}, selection, {
              image: image, front: tiles.front.toDataURL('image/png'), back: tiles.back.toDataURL('image/png')
            })), generation, 0, selection);
          }).catch(function (error) { finishUploadError(error, generation, 0); });
        } else {
          postMockup(JSON.stringify({ key: mockupKey, image: image }), generation, 0);
        }
      }, 400);
    }

    function queuePreview(immediate, placeholder) {
      var preview = ensurePreview();
      var sku = previewSku(state.product);
      if (!preview || !sku) {
        cancelMockupUpload(false);
        state.uploadError = propertiesValid();
        setPreviewStatus('error', 'This design is missing its preview artwork.');
        updateButtons();
        return;
      }
      clearTimeout(state.previewTimer);
      var request = ++state.previewRequest;
      var approvedValues = {
        name: state.previewValues.name,
        number: state.previewValues.number
      };
      state.previewTimer = setTimeout(function () {
        var values = placeholder
          ? {
              name: config.renderer === 'nfl-custom-jersey-2026' ? 'ANY NAME' : 'CUSTOMIZE',
              number: config.renderer === 'nfl-custom-jersey-2026' ? '00' : '99',
              track: 'name-and-number',
              _request: request,
              _sku: sku
            }
          : {
              name: approvedValues.name,
              number: approvedValues.number,
              track: approvedValues.number ? 'name-and-number' : 'name-only',
              _request: request,
              _sku: sku
            };
        var render = function () {
          if (request !== state.previewRequest) return null;
          values._numberSet = state.numberSetId;
          return preview.render(values).catch(function (error) {
            if (request !== state.previewRequest) return null;
            cancelMockupUpload(false);
            state.uploadError = propertiesValid();
            setPreviewStatus('error', error.message);
            updateButtons();
          });
        };
        if (state.previewSku !== sku) {
          showPreviewFallback();
          preview.loadProduct(sku).then(function (product) {
            if (!product || request !== state.previewRequest) return null;
            state.previewSku = sku;
            syncDesignNumberSet(product);
            return render();
          }).catch(function (error) {
            if (request !== state.previewRequest) return;
            cancelMockupUpload(false);
            state.uploadError = propertiesValid();
            setPreviewStatus('error', 'Unable to load this design preview.');
            updateButtons();
            console.error('[CustomJersey] Preview load error:', error);
          });
        } else {
          render();
        }
      }, immediate ? 0 : 160);
    }

    function renderCombinables(data) {
      state.combinables = data;
      var designIds = new Set();
      var results = (Array.isArray(data && data.results) ? data.results : []).map(function (group) {
        var seen = new Set();
        var products = (group.products || []).filter(function (product) {
          var id = productId(product) || product.handle;
          if (!id || seen.has(id)) return false;
          seen.add(id);
          designIds.add(id);
          return true;
        });
        return Object.assign({}, group, { products: products });
      }).filter(function (group) { return group.products.length; });
      roots.forEach(function (root) {
        var mount = root.querySelector('[data-custom-jersey-combinables]');
        if (!mount) return;
        mount.innerHTML = '';
        if (designIds.size < 2) return;
        var selectedGroup = Math.max(0, results.findIndex(function (group) {
          return (group.products || []).some(function (product) {
            return productId(product) === productId(state.product);
          });
        }));
        var tabs = document.createElement('div');
        tabs.className = 'combinable-tabs';
        var panes = document.createElement('div');
        panes.className = 'master-wrapper panes';

        function showGroup(index) {
          tabs.querySelectorAll('.combinable-tab').forEach(function (tab, tabIndex) {
            tab.classList.toggle('active', tabIndex === index);
          });
          panes.querySelectorAll('.group-pane').forEach(function (pane, paneIndex) {
            pane.classList.toggle('active', paneIndex === index);
          });
        }

        results.forEach(function (group, groupIndex) {
          if (results.length > 1) {
            var tab = document.createElement('button');
            tab.type = 'button';
            tab.className = 'combinable-tab';
            tab.textContent = String(group.collectionName || '').replace(/-/g, ' ');
            tab.addEventListener('click', function () { showGroup(groupIndex); });
            tabs.appendChild(tab);
          }
          var pane = document.createElement('div');
          pane.className = 'group-pane' + (groupIndex === selectedGroup ? ' active' : '');
          var label = document.createElement('div');
          label.className = 'combinable-label';
          label.textContent = 'Designs:';
          var items = document.createElement('div');
          items.className = 'combinable-items';
          (group.products || []).forEach(function (summary) {
            var anchor = document.createElement('a');
            anchor.href = '#';
            anchor.dataset.productId = productId(summary);
            anchor.classList.toggle('selected', productId(summary) === productId(state.product));
            anchor.setAttribute('aria-current', anchor.classList.contains('selected') ? 'true' : 'false');
            var image = document.createElement('img');
            image.alt = summary.title || 'Custom design';
            image.loading = 'lazy';
            image.src = summary.swatchUrl || summary.image && (summary.image.url || summary.image.src) || '';
            anchor.appendChild(image);
            productSummaries.set(anchor, summary);
            items.appendChild(anchor);
          });
          pane.appendChild(label);
          pane.appendChild(items);
          panes.appendChild(pane);
        });
        if (tabs.children.length) mount.appendChild(tabs);
        mount.appendChild(panes);
        showGroup(selectedGroup);
      });
    }

    function prefetchCombinables(data) {
      var preview = ensurePreview();
      if (!preview || !preview.prefetchProducts) return;
      var skus = [];
      (data.results || []).forEach(function (group) {
        (group.products || []).forEach(function (product) {
          var variants = product.variants || [];
          var variant = variants.find(function (item) { return /-LXL$/i.test(item.sku || ''); }) || variants[0];
          if (variant && variant.sku) skus.push(variant.sku);
        });
      });
      preview.prefetchProducts(skus.reverse(), { concurrency: global.innerWidth < 768 ? 1 : 2 });
    }

    function fetchCombinables() {
      window.RockEmCombinables.load({
        mode: config.combinablesSource,
        snapshot: config.combinables,
        endpoint: config.combinablesEndpoint,
        sku: config.product.variants[0].sku
      })
        .then(function (data) {
          console.log('[CustomJersey] Combinables response:', data);
          global.__COMBINABLES_DATA = data;
          renderCombinables(data);
          prefetchCombinables(data);
        })
        .catch(function (error) {
          roots.forEach(function (root) {
            var mount = root.querySelector('[data-custom-jersey-combinables]');
            if (mount) mount.innerHTML = '';
          });
          console.error('[CustomJersey] Combinables error:', error);
        });
    }

    function chooseDesign(anchor) {
      var summary = productSummaries.get(anchor);
      if (!summary || !summary.handle) return;
      if (config.renderer === 'nfl-custom-jersey-2026') cancelMockupUpload(false);
      state.selectionPending = true;
      updateButtons();
      var request = ++state.selectionRequest;
      var requestedSize = selectedSize(anchor.closest('[data-custom-jersey-product]'));
      roots.forEach(function (root) {
        var mount = root.querySelector('[data-custom-jersey-combinables]');
        if (mount) mount.classList.add('is-switching');
      });
      fetch((global.Shopify && global.Shopify.routes && global.Shopify.routes.root || '/') +
        'products/' + encodeURIComponent(summary.handle) + '.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Product request failed with ' + response.status);
          return response.json();
        })
        .then(function (product) {
          if (request !== state.selectionRequest) return;
          var variant = findVariant(product, requestedSize);
          var sizeExists = requestedSize && (product.variants || []).some(function (item) {
            return variantSize(product, item).toLowerCase() === requestedSize.toLowerCase();
          });
          state.product = product;
          state.selectedSize = sizeExists ? requestedSize : '';
          state.previewSku = '';
          state.numberSetId = '';
          state.numberSetImages = {};
          cancelMockupUpload(propertiesValid());
          state.mockupKey = makeMockupKey();
          initSwatches(product, variant);
          applyVariant(variant, { productChanged: true });
          roots.forEach(function (root) { markSize(root, state.selectedSize); });
          renderCombinables(state.combinables);
          queuePreview(true, !state.values.name);
        })
        .catch(function (error) {
          console.error('[CustomJersey] Design switch error:', error);
        })
        .finally(function () {
          if (request !== state.selectionRequest) return;
          state.selectionPending = false;
          updateButtons();
          roots.forEach(function (root) {
            var mount = root.querySelector('[data-custom-jersey-combinables]');
            if (mount) mount.classList.remove('is-switching');
          });
        });
    }

    document.addEventListener('touchstart', function (event) {
      if (event.target.closest('[data-custom-jersey-product] .new-options-list li')) {
        event.stopPropagation();
      }
    }, { capture: true, passive: true });

    document.addEventListener('click', function (event) {
      var design = event.target.closest('[data-custom-jersey-combinables] .combinable-items a');
      if (design) {
        event.preventDefault();
        event.stopPropagation();
        chooseDesign(design);
        return;
      }
      var root = event.target.closest('[data-custom-jersey-product]');
      if (!root) return;
      var tab = event.target.closest('.new-toggle-item');
      if (tab) {
        event.preventDefault();
        event.stopPropagation();
        switchSizeTab(root, tab);
        return;
      }
      var pill = event.target.closest('.new-options-list li');
      if (pill) {
        var link = pill.querySelector('a[data-value]');
        if (!link) return;
        event.preventDefault();
        event.stopPropagation();
        selectSize(root, link.dataset.value.trim());
        return;
      }
      var addButton = event.target.closest('.btn-addtocart');
      if (addButton) {
        readCustomization(root);
        if (config.renderer === 'nfl-custom-jersey-2026') {
          event.preventDefault();
          event.stopPropagation();
          preparePurchase(addButton.closest('form'));
          return;
        }
        if (state.uploadError && state.selectedSize && propertiesValid() &&
            state.variant && state.variant.available) {
          event.preventDefault();
          event.stopPropagation();
          cancelMockupUpload(true);
          updateButtons();
          queuePreview(true, false);
          return;
        }
        if (!state.selectedSize || !propertiesValid() || state.uploadPending ||
            !state.mockupUrl || !state.variant || !state.variant.available || !jerseyArtworkReady()) {
          event.preventDefault();
          event.stopPropagation();
          updateButtons();
          return;
        }
        syncProperties();
        setFormVariant(state.variant);
        setTimeout(function () { state.mockupKey = makeMockupKey(); }, 0);
      }
    }, true);

    function applyCustomization(numberChanged) {
      syncProperties();
      updateValidation();
      if (containsBadWord(state.values.name) || (state.values.name !== '' && nameValidation.nameError(state.values.name))) {
        clearTimeout(state.previewTimer);
        state.previewRequest += 1;
        state.previewValues = { name: '', number: state.values.number };
        cancelMockupUpload(false);
        updateButtons();
        queuePreview(true, !state.values.number);
      } else if (state.values.name || state.values.number) {
        state.previewValues = {
          name: state.values.name,
          number: config.renderer === 'nfl-custom-jersey-2026' && !/^\d{0,2}$/.test(state.values.number)
            ? state.previewValues.number : state.values.number
        };
        cancelMockupUpload(propertiesValid());
        updateButtons();
        queuePreview(numberChanged, false);
      } else {
        state.previewValues = { name: '', number: '' };
        cancelMockupUpload(false);
        updateButtons();
        queuePreview(true, true);
      }
    }

    // Autofill and scripts can change .value without an input event. Validate
    // the submitted root again before preparing artwork and before serialization.
    function readCustomization(root) {
      if (!root) return;
      var name = root.querySelector('.custom-jersey-name');
      var number = root.querySelector('.custom-jersey-number');
      var nextName = name ? name.value.toUpperCase() : state.values.name;
      var nextNumber = number ? number.value : state.values.number;
      if (nextName === state.values.name && nextNumber === state.values.number) return;
      var numberChanged = nextNumber !== state.values.number;
      state.values = { name: nextName, number: nextNumber };
      applyCustomization(numberChanged);
    }

    function handleCustomizationInput(event) {
      if (!event.target.closest('[data-custom-jersey-product]')) return;
      if (event.target.matches('.custom-jersey-number')) {
        state.values.number = event.target.value.replace(/[^0-9]/g, '').slice(0, 2);
      } else if (event.target.matches('.custom-jersey-name')) {
        state.values.name = event.target.value.replace(/[^a-z ]/gi, '').toUpperCase().slice(0, 12);
      } else {
        return;
      }
      event.target.value = event.target.matches('.custom-jersey-number') ? state.values.number : state.values.name;
      applyCustomization(event.target.matches('.custom-jersey-number'));
    }

    document.addEventListener('input', handleCustomizationInput);
    document.addEventListener('change', handleCustomizationInput);

    document.addEventListener('focusout', function (event) {
      if (event.target.matches('.custom-jersey-name, .custom-jersey-number')) handleCustomizationInput(event);
    });

    document.addEventListener('submit', function (event) {
      if (!event.target.closest('[data-custom-jersey-product]')) return;
      readCustomization(event.target.closest('[data-custom-jersey-product]'));
      if (config.renderer === 'nfl-custom-jersey-2026') {
        event.preventDefault();
        event.stopPropagation();
        preparePurchase(event.target);
        return;
      }
      if (!state.selectedSize || !propertiesValid() || state.uploadPending ||
          !state.mockupUrl || !state.variant || !state.variant.available || !jerseyArtworkReady()) {
        event.preventDefault();
        event.stopPropagation();
        updateButtons();
        return;
      }
      syncProperties();
      setFormVariant(state.variant);
    }, true);

    state.variant = findVariant(
      state.product,
      variantSize(
        state.product,
        (state.product.variants || []).find(function (variant) {
          return String(variant.id) === String(config.selectedVariantId);
        })
      )
    );
    syncProperties();
    initSwatches(state.product, state.variant);
    applyVariant(state.variant, { updateUrl: false });
    updateValidation();
    queuePreview(true, true);
    fetchCombinables();
  });
})(window);
